export default "__VITE_ASSET__V3yZI7D2__"